import styled from 'styled-components';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';


export const ModalBody = styled(Modal.Body)`
  padding: 40px 60px;
`

export const ModalFooter = styled(Modal.Footer)`
  padding-bottom: 35px;
  display: flex;
  justify-content: center;
  border-top: 0;
`;

export const ModalClose = styled(Button)`
  position: absolute;
  top: -14px;
  right: -12px;
  padding: 10px;
  background: #fff;
  border-radius: 100%;
  border-width: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: radial-gradient(100% 100% at 0% 0%, rgba(221, 227, 250, 0.99) 0%, rgba(221, 229, 250, 0.4) 100%);
  &:hover{
    box-shadow: none;
    border-radius: 100%;
    border-width: 0;
  }
  &:focus{
    border-width: 0;
    box-shadow: inset 4px 4px 4px rgba(0, 0, 0, 0.15);
    border-radius: 100%;
  }
`

export const StyledImg = styled.img`
  width: 100%;
  &.rotate{
    transform: rotate(40deg);
  }
`;

export const H3 = styled.h3`
  font-family: Manrope, sans-serif;
  font-weight: 600;
  font-size: 24px;
  line-height: 36px;
  margin-bottom: 50px;
`

export const H5 = styled.h5`
  font-family: Manrope, sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 20px;
`

export const Textarea = styled.textarea`
  color: #000;
  font-family: OpenSans, sans-serif;
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  background: #ffffff;
  backdrop-filter: blur(10px);
  border-radius: 8px;
  resize: none;
  width: 100%;
  border: 1px solid #fff;
  padding: 14px 18px;
  margin-bottom: 20px;
  &:focus{
    box-shadow: none;
    outline: none;
  }
  &::placeholder{
    color: #828282;
  }
`

export const TextHelper = styled.p`
  font-family: OpenSans, sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: #808387
`

export const Text = styled.p`
  font-family: OpenSans, sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 25px;
`

export const StyledModalBtn = styled(Button)`
  &.FeedbackFooter{
    width: 162px;
    height: 50px;
    background: linear-gradient(90.82deg, #1CCCEF -33.3%, #1C62EF 84.24%);
    border-radius: 8px;
    border-width: 0;

    &:hover{
      background: linear-gradient(90.82deg, #1CCCEF -33.3%, #1C62EF 84.24%);
      box-shadow: -8.49px -8.49px 5px rgba(255, 255, 255, 0.33), 8.17px 8.17px 12px rgba(36, 38, 89, 0.1);
      border-radius: 8px;
      border-width: 0;
    }
    &:focus{
      border-width: 0;
      background: linear-gradient(90.82deg, #1CCCEF -33.3%, #1C62EF 84.24%);
      box-shadow: inset 4px 4px 4px rgba(0, 0, 0, 0.15);
      border-radius: 8px;
    }
  }
`

export const ErrorText = styled.p`
  font-family: OpenSans, sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: red;
`

export const InviteParagraph = styled.p`
  font-family: Manrope, sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 154%;
  text-align: center;
  color: #4F5388;
  margin-bottom: 43px;
  & p{
    margin-top: 20px;
  }
`;